import React, { useState } from "react";
import { Link } from "react-router-dom"; // ✅ IMPORT THIS
import "./Navbar.css";
import logo from '../images/doddamaniTech.png';

function Navbar() {

  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">

      <div className="nav-container">

        <div className="logo-container">
          <img src={logo} alt="Doddamani TechDev Logo" />
        </div>

        <div className={`nav-links ${menuOpen ? "active" : ""}`}>

          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <Link to="/services">Services</Link>
          <Link to="/ourtechnologies">Our Technologies</Link>
          <Link to="/products">Products</Link>
          <Link to="/training">Training</Link>
          <Link to="/contact" className="contact-btn">Contact</Link>

        </div>

        <div 
          className={`hamburger ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

      </div>

    </nav>
  );
}

export default Navbar;